import { Drawer, Grid, Stack } from "@mui/material";
import DrawerMenu from "./DrawerMenu";
import { Link } from "react-router-dom";


type Props = {
  openDrawer: boolean;
  setOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>;
};

function HeaderDrawer({ openDrawer, setOpenDrawer }: Props) {

  return (
    <Drawer
      anchor={"left"}
      open={openDrawer}
      onClose={() => setOpenDrawer(false)}
      sx={{
        "& .MuiDrawer-paper": {
          width: "100%",
          maxWidth: "300px",
          padding: "20px",
          backgroundColor : "#f9f9f9",
        },
      }}
    >
      <Stack borderRadius={4} my={5}>

        <DrawerMenu setOpenDrawer={setOpenDrawer} />
      </Stack>
    </Drawer>
  );
}

export default HeaderDrawer;
